import { useId } from "react";

export function YarnBall({ size = 40, color = "#C85A32", className = "" }) {
  const clip = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
      <defs>
        <clipPath id={clip}>
          <circle cx="30" cy="30" r="24" />
        </clipPath>
      </defs>
      <path d="M46 47 Q56 52 52 58 Q49 62 60 62" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" />
      <circle cx="30" cy="30" r="24" fill={color} />
      <g clipPath={`url(#${clip})`} fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="2.4" strokeLinecap="round">
        <path d="M4 20 Q30 10 58 26" />
        <path d="M4 31 Q30 20 58 37" />
        <path d="M6 43 Q32 32 58 48" />
        <path d="M20 2 Q10 30 24 60" />
        <path d="M38 2 Q50 30 36 60" />
      </g>
      <circle cx="30" cy="30" r="24" fill="none" stroke="rgba(0,0,0,0.12)" strokeWidth="2" />
    </svg>
  );
}
